import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MainLogo } from './mainLogo';

export default function Navbar() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const location = useLocation();

  const getLinkClass = (path) => {
    const isActive = location.pathname === path;
    return `kr-font ${isActive ? 'text-primary font-bold' : 'text-secondary-text'} hover:text-primary`;
  };

  const handleDrawerToggle = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  return (
    <nav className="bg-white shadow-lg px-[16px] tablet:pr-[35px] tablet:pl-[16px]">
      <div className="max-w-[1480px] mx-auto tablet:py-4 py-2">
        <div className="flex justify-between items-center">
          <MainLogo className="tablet:w-[260px] w-[230px]" />

          {/* 데스크탑 메뉴 */}
          <div className="hidden tablet:flex space-x-8 text-headline-small font-inter font-semibold whitespace-nowrap">
            <Link to="/" className={getLinkClass('/')}>
              About anatole
            </Link>

            <Link to="/admission" className={getLinkClass('/admission')}>
              입학안내
            </Link>

            <Link to="/campus" className={getLinkClass('/campus')}>
              학원찾기
            </Link>

            <Link to="/news" className={getLinkClass('/news')}>
              캠퍼스소식
            </Link>

            <Link to="/inquiry" className={getLinkClass('/inquiry')}>
              입학문의
            </Link>
          </div>

          {/* 모바일 메뉴 버튼 */}
          <div className="tablet:hidden">
            <button
              onClick={handleDrawerToggle}
              className="text-secondary-text mr-4 flex items-center"
              aria-label="메뉴 열기"
            >
              <svg className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* 모바일 Drawer */}
      <div
        className={`fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300 ${isDrawerOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
          }`}
        onClick={handleDrawerToggle}
      >
        <div
          className={`fixed right-0 top-0 h-full w-64 bg-white shadow-lg transform transition-transform duration-300 ${isDrawerOpen ? 'translate-x-0' : 'translate-x-full'
            }`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="p-6">
            <button
              onClick={handleDrawerToggle}
              className="text-secondary-text mb-8"
              aria-label="메뉴 닫기"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            <div className="flex flex-col space-y-6 text-title-large">
              <Link to="/" className={getLinkClass('/')} onClick={handleDrawerToggle}>
                홈
              </Link>
              <Link to="/admission" className={getLinkClass('/admission')} onClick={handleDrawerToggle}>
                입학안내
              </Link>
              <Link to="/campus" className={getLinkClass('/campus')} onClick={handleDrawerToggle}>
                학원찾기
              </Link>
              <Link to="/news" className={getLinkClass('/news')} onClick={handleDrawerToggle}>
                캠퍼스소식
              </Link>
              <Link to="/inquiry" className={getLinkClass('/inquiry')} onClick={handleDrawerToggle}>
                입학문의
              </Link>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}